import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { Room } from '@/types/room.types';

export interface RoomsParams {
  status?: string; // Cleaning Status
  type?: string;
  floor?: number;
  per_page?: number;
}

interface RawRoomsResponse {
  success: boolean;
  data: {
    rooms: {
      data: Room[];
      current_page: number;
      last_page: number;
      total: number;
      per_page: number;
    };
  };
}

export const useRoomsQuery = (params?: RoomsParams) => {
  const merged = { per_page: 200, ...params };
  return useQuery({
    queryKey: ['rooms', merged],
    queryFn: async (): Promise<Room[]> => {
      const { data } = await api.get<RawRoomsResponse>('/v1/quartos', {
        params: merged,
      });
      return data.data?.rooms?.data ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useUpdateRoomStatusMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id, status }: { id: string | number; status: string }) => {
            const { data } = await api.patch(`/v1/quartos/${id}/situacao`, {
                status,
            });
            return data;
        },
        onSuccess: () => {
             queryClient.invalidateQueries({ queryKey: ['rooms'] });
             queryClient.invalidateQueries({ queryKey: ['housekeeping'] });
             queryClient.invalidateQueries({ queryKey: ['dashboard', 'stats'] }); // Occupancy might change
        }
    });
};
